import React from "react";
import Loader from "react-loader-spinner";
import { Formik, Form } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";

import {
  ButtonGroup,
  StyledBankTransferFormButton,
  colors,
} from "../../../../../../Syles/styles";
import { BankTranferDetailsTextInput } from "./../../../../../Formik/BankDetailsInput";
import { $api } from "../../../../../../../helpers/$api";

const CryptoAccount = ({ exitModal }) => {
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true);
      await $api.user.addCryptoWallet(values);
      toast.success("wallet added successfully");
      exitModal();
    } catch (error) {
      toast.error(`error submitting wallet - ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <div className="crypto-section">
      <h1>Add Crypto Wallet</h1>
      <div className="formSection">
        <Formik
          initialValues={{
            coin_host: "",
            wallet_address: "",
          }}
          onSubmit={handleSubmit}
          validationSchema={Yup.object({
            coin_host: Yup.string().required("Coin-host is required"),
            wallet_address: Yup.string().required("Wallet Address is required"),
          })}
        >
          {({ isSubmitting }) => (
            <Form className="crypto-form">
              <BankTranferDetailsTextInput
                name="coin_host"
                type="text"
                placeholder="coin host"
              />

              <BankTranferDetailsTextInput
                className="mt-5"
                name="wallet_address"
                type="text"
                placeholder="Wallet address"
              />
              <ButtonGroup className="button-group">
                {!isSubmitting && (
                  <StyledBankTransferFormButton type="submit">
                    Add Wallet Address
                  </StyledBankTransferFormButton>
                )}

                {isSubmitting && (
                  <Loader
                    type="ThreeDots"
                    color={colors.primary}
                    height={49}
                    width={100}
                  />
                )}
              </ButtonGroup>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CryptoAccount;
